import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expression-redo",
  "use": "icon-expression-redo-usage",
  "viewBox": "0 0 15.199999809265137 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 15.199999809265137 16\" id=\"icon-expression-redo\"><g><path d=\"M10.4,6L6.4,6C3.74903,6,2.8,6.94903,2.8,9.6C2.8,12.251,3.74903,13.2,6.4,13.2L13.6,13.2L13.6,16L6.4,16C2.86538,16,0,13.1346,0,9.6C0,6.06538,2.86538,3.2,6.4,3.2L10.4,3.2L10.4,0L15.2,4L10.4,8L10.4,6Z\" fill=\"currentColor\" fill-opacity=\"0.6499999761581421\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol